import React from "react";
import { Navigate } from "react-router-dom";

export const LoginRoute = ({ component: Component }) => {
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  return isLoggedIn ? <Navigate to="/" /> : <Component />;
};
